<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Li Lingao
 * @Date: 2020-08-20 17:31:39
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-09-17 16:17:23
-->
<template>
  <div class="left-chart-21">
    <div class="lc2-header">
      <dv-decoration-7 style="width:150px;height:30px;font-size:18px;">网办深度统计</dv-decoration-7>
    </div>
    <dv-charts class="lc2-chart" :option="option" />
    <dv-decoration-2 style="height:10px;" />
  </div>
</template>

<script>
import ns from "@/services/NetService.js"
export default {
  name: 'LeftChart21',
  data() {
    return {
      option: {
        series: [
          {
            type: 'pie',
            data: [
              { name: '四级网办', value: 1352 },
              { name: '三级网办', value: 297 },
              { name: '二级网办', value: 87 },
              { name: '不网办', value: 248 }
            ],
            radius: ['40%', '75%'],
            insideLabel: {
              show: true,
            },
            outsideLabel: {
              labelLineEndLength: 20,
              formatter: '{name}\n{value}\n{percent}%',
              style: {
                fontSize: 12,
                fill: '#000'
              }
            }
          }
        ],
        color: ['#00baff', '#3de7c9', '#ffc530', '#469f4b'],
      }
    }
  },
  methods: {
    init() {
      // ns.post('/getOperationData', {
      //   key: 'ONLINEDEPTH_ANALYSIS_QD',
      // }).then((res) => {
      //   let list = res.data[0].ANALYSIS_VALUE
      //   this.option.series[0].data = list
      // }).catch(err => {
      //   console.error(err)
      // })
    }
  },
  created() {
    this.init();
  }
}
</script>

<style lang="less">
.left-chart-21 {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;

  .lc2-header {
    height: 10px;
    line-height: 18px;
    font-size: 18px;
    text-indent: 20px;
    margin-top: 10px;
  }

  .lc2-details {
    height: 30px;
    font-size: 26px;
    display: flex;
    align-items: center;
    text-indent: 20px;

    span {
      color: #096dd9;
      font-weight: bold;
      font-size: 35px;
      margin-left: 20px;
    }
  }

  .lc2-chart {
    color: #000;
    height: calc(~"100% - 20px");
    padding-top: 40px;
  }
}
</style>
